// extracted by mini-css-extract-plugin
export default {"dataArea":"Subscription_dataArea__v9+wQ","recipientArea":"Subscription_recipientArea__UlJ68"};